import React from 'react';
import { FDIcon, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const OutcomeActionLineItemLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={2} alignItems={'center'} width={'100%'} {...dataAttrs('outcome-action-line-item')}>
      {resource.attr('icon') && <FDIcon icon={resource.attr('icon')} />}
      <MetaControlField attr={'description'} />
    </FDStack>
  );
};

export { OutcomeActionLineItemLayout };
